import defineElement from "../helpers/defineElement.js";

/**
 * Element to wrap some text.
 * By default, it will do nothing
 *
 * @param {object} [options]
 * @param {boolean} [options.emphasize] - When true, the text will be emphasized to the
 *   appreciation of the design system (probably bold or italic)
 * @param {boolean} [options.important] - When true, the text will be displayed in a
 *   more prominent way. It fits well title or main info
 * @param {boolean} [options.subtle] - When true, the text will be displayed in a more
 *   subtle way. It fits well information or descriptions
 * @param {boolean} [options.loading] - When true, the text shows that it is
 *   linked to a loading part of the application
 * @param {boolean} [options.ellipsis] - When true, the overflow is
 *   hidden and an ellipsis is rendered instead
 */

export default defineElement(
	"text",
	({
		emphasize = false,
		important = false,
		subtle = false,
		loading = false,
		ellipsis = false,
	}) => ({
		tag: "span",
		options: { class: { emphasize, important, subtle, loading, ellipsis } },
	}),
);
